const API_URL = process.env.REACT_APP_API_URL || ""
const SENTRY_URL = process.env.REACT_APP_SENTRY_URL || ""
const DEFAULT_APP_SLUG = process.env.REACT_APP_DEFAULT_APP_SLUG || "default000001"
const CAPTCHA_SITEKEY = process.env.REACT_APP_CAPTCHA_SITEKEY || ""

export { API_URL }
export { CAPTCHA_SITEKEY }
export { SENTRY_URL }
export { DEFAULT_APP_SLUG }
